import { WishlistsStorefrontValuesBrandingEntity } from "@apps/wishlist/entities/WishlistsStorefrontValuesBrandingEntity";

export const BUTTON_VARIANT: Record<
    WishlistsStorefrontValuesBrandingEntity["wishlistButtonSettings"]["style"],
    "outlined" | "contained"
> = {
    filled: "contained",
    outlined: "outlined",
};
